var _clipPath, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmenitiesIconsDining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.11133 7.11133h17.7778v17.7778h-17.7778z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#c9002c",
    r: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.8891 10.4447c0-1.84115-1.2434-3.33337-2.7778-3.33337-1.5345 0-2.7778 1.49222-2.7778 3.33337 0 1.59.9289 2.9144 2.17 3.2477l-1.0478 9.3423c-.0078.0611-.0111.1244-.0111.1877 0 .92.7467 1.6667 1.6667 1.6667s1.6666-.7467 1.6666-1.6667c0-.0533-.0022-.1066-.0077-.1588l-.8911-9.4312c1.1577-.4011 2.01-1.6688 2.01-3.1877z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.1113 7.11133c-.3066 0-.5555.24889-.5555.55555v2.77782c0 .3066-.2489.5555-.5556.5555-.3066 0-.5555-.2489-.5555-.5555v-2.77782c0-.30666-.2489-.55555-.5556-.55555s-.5555.24889-.5555.55555v2.77782c0 .3066-.2489.5555-.5556.5555s-.5556-.2489-.5556-.5555v-2.77782c0-.30666-.2488-.55555-.5555-.55555s-.5556.24889-.5556.55555v3.33332c0 1.3211.9289 2.4267 2.1678 2.7056l-1.0467 9.3289c-.0066.0611-.01.1244-.01.1877 0 .92.7467 1.6667 1.6667 1.6667s1.6667-.7467 1.6667-1.6667c0-.0533-.0022-.1066-.0078-.1588l-.8889-9.4078c1.1556-.3367 2.0078-1.3934 2.0078-2.6556v-3.33332c0-.30666-.2489-.55555-.5556-.55555z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmenitiesIconsDining);
export default __webpack_public_path__ + "static/media/AmenitiesIconsDining.95e42d9b6349332f7c639e4b24907e34.svg";
export { ForwardRef as ReactComponent };